import { post } from '../utility';

export const getPurchasedGallons = ({ fuelContractId, callback }) => {
	post({
		method: 'fuelContract.getPurchasedGallons',
		params: { fuelContractId },
		callback,
	});
};
